import data from "@/config/template/CustomLogin/data.json"
import { CurrentAppResp } from "@/page/App/resp/currentAppResp"

export const CUSTOM_LOGIN_DATA = data as unknown as CurrentAppResp
